import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

type ItemLookupProps = {
  onSubmit: (event: React.FormEvent) => void;
  title: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  loading?: boolean;
  disabled?: boolean;
};

export const ItemLookup = ({
  onSubmit,
  title,
  placeholder,
  value,
  onChange,
  loading,
}: ItemLookupProps) => {
  return (
    <form onSubmit={onSubmit}>
      <TextField
        type='string'
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        label={title}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        disabled={loading}
        InputProps={{
          endAdornment: (
            <Button
              type='submit'
              variant='contained'
              disabled={loading || !value}
            >
              Go
            </Button>
          ),
        }}
      />
    </form>
  );
};
